import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerApiRequest } from '../ticket-manager.api';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

export const buildPickNextQueueTicketRequest = ({
  projectId,
  queueId,
  userId,
}: {
  projectId: string;
  queueId: string;
  userId: string;
}): TicketManagerApiRequest => ({
  data: {
    user_id: userId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/queues/${queueId}/assign`,
});
